import { Checkbox, GroupBox } from '@infotech-soe/erp-ui-kit';
import { IFormatterContext } from '@infotech-soe/metaschema';
import chunk from 'lodash/chunk';
import identity from 'lodash/identity';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';
import { InputConditionsProps, InputName } from './types';

const EnumConditions = ({
  column: { domain, formatter },
  condition: { value },
  onChange,
}: InputConditionsProps<boolean>): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const selectedValues = value.scope || [];

  return (
    <GroupBox label={formatMessage(messages.condition)}>
      {chunk<string | number>(domain.values, Math.ceil(2)).map(
        (group, rowIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className="row m-mb-sm" key={rowIndex}>
            {group.map(domainValue => (
              <div className="col" key={domainValue}>
                <Checkbox
                  className="col-auto"
                  name={String(domainValue)}
                  label={
                    formatter
                      ? formatter(domainValue, {} as IFormatterContext)
                      : identity(domainValue)
                  }
                  value={selectedValues.includes(domainValue)}
                  onChange={checked => {
                    const list = checked
                      ? [...selectedValues, domainValue]
                      : selectedValues.filter(
                          (lValue: string | number) => lValue !== domainValue
                        );
                    onChange(list, InputName.SCOPE);
                  }}
                />
              </div>
            ))}
          </div>
        )
      )}
    </GroupBox>
  );
};

export default memo(EnumConditions);
